import { connect } from 'react-redux';
import Blog from './components/Blog';

import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';
import {
  loadAmberReport,
  loadAmberReportFeeds,
  loadAmberReportTags,
  filterAmberReports,
  setAmberReportsAsSeen,
  setAmberReportUnseen,
  setAmberReportSeen,
} from '../../redux/actions/blog';
import { closeFilterSidebar, applyFilters } from '../../redux/actions/filters';
import { updateTag } from '../../redux/actions';
import { updateIocList } from '../../redux/actions';

const mapStateToProps = (state) => ({
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  availableBlogs: state.blog.availableBlogs,
  availableBlogsStatus: state.blog.availableBlogsStatus,
  blog: state.blog.blog,
  blogStatus: state.blog.blogStatus,
  amberReportFeeds: state.blog.amberReportFeeds,
  amberReportFeedsStatus: state.blog.amberReportFeedsStatus,
  amberReportTags: state.blog.amberReportTags,
  amberReportTagsStatus: state.blog.amberReportTagsStatus,
  amberReportCount: state.blog.amberReportCount,
  threatRankingListPagination: state.ioc.pagination,
  threatRankingListSorting: state.ioc.sorting,
});

const mapDispatchToProps = {
  loadUser,
  loadMySubscriptionPlan,
  loadAmberReport,
  loadAmberReportFeeds,
  loadAmberReportTags,
  filterAmberReports,
  setAmberReportsAsSeen,
  setAmberReportUnseen,
  setAmberReportSeen,
  closeFilterSidebar,
  applyFilters,
  updateTag,
  updateIocList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
